const toJson = async <T>(response: Response): Promise<{ data?: T }> =>
  response.json();

export default toJson;
